import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SignIn from './pages/SignIn';
import Home from './pages/Home';
import Loading from './components/Loading';
import Copyright from './components/Copyright';
import AcademicCalendar from './pages/Calendar';
import { Schools } from './components/Schools'; // New searchable component
import './App.css';
import '@fontsource/inter';
import CurrentTime from './components/CurrentTime';
import DynamicIsland from './components/DynamicIsland';
import UserProfile from './pages/UserProfile';
import StudentCard from './pages/StudentCard';
import CampusMap from './pages/Map';
import TechHelp from './pages/TechHelp';
import CampusBoard from './pages/CampusBoard';
import NewsFeed from './pages/News';
import Messaging from './pages/Messaging';
import CampusRec from './pages/CampusRec';
import Health from './pages/Health';
import Library from './pages/Library';
import CampusLife from './pages/CampusLife';
import StudentEvent from './pages/StudentEvents';


function App() {
  const [school, setSchool] = useState(""); // Track the selected school
  const [schoolError, setSchoolError] = useState(""); // Track the school selection error

  const schools = [
    { name: "Towson University", logo: "./img/towson-logo.png" },
    { name: "Harvard University", logo: "./img/harvard-logo.png" },
    { name: "Stanford University", logo: "./img/stanford-logo.png" },
  ];

  const handleSchoolSelect = (selectedSchool) => {
    setSchoolError(""); // Clear any previous errors
    setSchool(selectedSchool.name); // Store the name of the school
  };

  const handleContinueToLogin = () => {
    if (!school) {
      setSchoolError('Please select a school before proceeding.');
      return;
    }
    window.location.href = "/sign-in";
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <section className={`container ${school ? school.replace(/\s+/g, '-').toLowerCase() : ''}`}> 
              <CurrentTime />
              <DynamicIsland />
              <h1 className="app-title">CampusEdu</h1>
              <p className="tagline">Keep on Learning</p>
              <p className="search-instruction">Please search for your school</p>

              <Schools 
                schools={schools} 
                onSchoolSelect={handleSchoolSelect} 
              />
              <p>You have selected: {school}</p> 

              {schoolError && <p className="school-error-message">{schoolError}</p>}

              <button
                className="login-button link-text"
                onClick={handleContinueToLogin} 
              >
                Continue to Login
              </button>

              <Copyright />
            </section>
          }
        />
        <Route
          path="/sign-in"
          element={<SignIn school={school} />} // Pass selected school name as a string to SignIn
        />
        <Route path="/campus-board" element={<CampusBoard />} />
        <Route path="/tech-help" element={<TechHelp />} />
        <Route path="/campus-map" element={<CampusMap />} />
        <Route path="/student-card" element={<StudentCard />} />        
        <Route path="/home" element={<Home school={school} />} />
        <Route path="/user-profile" element={<UserProfile />} />
        <Route path="/loading" element={<Loading school={school} />} />
        <Route path="/calendar" element={<AcademicCalendar />} />
        <Route path="/news-feed" element={<NewsFeed />} />
        <Route path="/student-messaging" element={<Messaging />} />
        <Route path="/campus-rec" element={<CampusRec />} />
        <Route path="/tech-help" element={<TechHelp />} />
        <Route path="/health-center" element={<Health/>}/>
        <Route path="/cook-library" element={<Library/>}/>
        <Route path="/campus-life" element={<CampusLife/>}/>
        <Route path="/student-events" element={<StudentEvent/>}/>
      </Routes>
    </Router>
  );
}

export default App;
